import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
// import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface ReasonDoubleCitizenshipProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
}

const ReasonDoubleCitizenshipComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Motivo',
}: ReasonDoubleCitizenshipProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="reason-citizenship-label">
        {label}
      </InputLabel>
      <PmiSelect
        labelId="reason-citizenship-label"
        id="reason-citizenship"
        name="reason-citizenship"
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {/* TODO
        {reasons.map((reason: ItemVM) => (
          <MenuItem key={reason.id} value={reason.id}>
            {reason.value}
          </MenuItem>
        ))} */}
      </PmiSelect>
    </PmiFormControl>
  );
};

ReasonDoubleCitizenshipComponent.displayName = 'Reason Double Citizenship list component';

const ReasonDoubleCitizenship = memo(ReasonDoubleCitizenshipComponent);

export default ReasonDoubleCitizenship as typeof ReasonDoubleCitizenshipComponent;
